'use client';
import { BadgeProps, Badge as HeroUiBadge } from '@heroui/badge';
import { extendVariants, InternalForwardRefRenderFunction } from '@heroui/system';

export const Badge = extendVariants(HeroUiBadge, {});

(Badge as InternalForwardRefRenderFunction<'span', BadgeProps, never>).defaultProps = {
  variant: 'shadow',
  color: 'primary',
};
